import { RootState } from '../../RootState';
import { StateSettings } from '../SettingsState';

const selectRequiredSettings = (state: RootState): StateSettings => {
  const settings: StateSettings | null = state.settings.settings;
  if (settings === null) {
    throw new Error('Settings should be initialized.');
  }

  return settings;
};

export default selectRequiredSettings;
